import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";
import _ from "lodash";
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";

export default async function Report(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);
        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);
        const additionalColumn = {
            label: "Operador",
            field: "operador.operador",
            width: "*",
        };

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                undefined,
                undefined,
                additionalColumn,
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Coleta (cm)", "Conforme"],
                // prettier-ignore
                (h) => [
                    h.numberField("coleta"),
                    h.textField("conforme"),
                ],
                [60, 60],
            ),

            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "cm"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}

function thisReaderReport(visita, indicador, apontamento, params, optLabelConformidade) {
    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;

    if (_.isEmpty(params)) {
        return h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra)
                ),

                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                ),
            ],
            { widths: [60, "*"] },
        );
    }
    const status = IndicadorClass.getConformidadeStatus(apontamento.conformidade, params.meta);

    const content = [
        h.panel(
            [
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra),
                    h.title("Tipo"),
                    h.textField("tipo"),
                    h.title("Meta (%)"),
                    h.text(params.meta),
                ),
            ],
            { widths: [60, "*", 50, 70, 45, 40] },
        ),

        h.panel(
            [
                h.row(
                    h.title("Talhão"),
                    h.title("Trator"),
                    h.title("Equipamento"),
                    h.title("Frente"),
                    h.title(optLabelConformidade || "Conformidade (%)", { alignment: "right" }),
                ),

                h.row(
                    h.textField("talhao.nome"),
                    h.textField("trator.numeroFrotaTrator"),
                    h.textField("equipamento"),
                    h.textField("frente"),
                    h.conformidadeField("conformidade", status, { alignment: "right" }),
                ),
            ],
            { widths: [60, "*", "*", 125, 90] },
        ),
    ];

    return h.unbreakable(content);
}
